<template>
  <div>
    <!-- info -->
    <section class="info" v-if="details != ''">
      <h3>基本信息</h3>
      <ul>
        <li>
          <label>项目名称：</label>
          <p>{{ details.project_name }}</p>
        </li>
        <li>
          <label>公寓名称：</label>
          <p>{{ details.name }}</p>
        </li>
        <li>
          <label>地址：</label>
          <p>
            {{
              details.province == details.city
                ? details.city + details.area + details.address
                : details.province +
                  details.city +
                  details.area +
                  details.address
            }}
          </p>
        </li>
        <li>
          <label>卫生间类型：</label>
          <p v-if="details.washroom_type == 1">单卫</p>
          <p v-else-if="details.washroom_type == 2">双卫</p>
          <p v-else-if="details.washroom_type == 3">三卫</p>
        </li>
        <li>
          <label>厅室：</label>
          <p>{{ details.room + "室户" }}</p>
        </li>
        <li v-show="details.room != 0">
          <label>室号：</label>
          <p>{{ details.room_number }}</p>
        </li>
        <li>
          <label>是否为复式：</label>
          <p v-if="details.is_compound == 1">是</p>
          <p v-else-if="details.is_compound == 2">否</p>
          <p v-else>未知</p>
        </li>
        <li>
          <label>密码：</label>
          <p v-if="details.password_type == 1">{{ details.password }}</p>
          <p v-else-if="details.password_type == 2">临时密码</p>
          <p v-else>未知</p>
        </li>
        <li>
          <label>备注：</label>
          <p>{{ details.remark }}</p>
        </li>
      </ul>
    </section>
    <section v-if="details != ''" class="info">
      <h3>其他信息</h3>
      <ul>
        <li>
          <label>综合员工：</label>
          <p>{{ details.customer_user_names }}</p>
        </li>
        <li>
          <label>创建时间：</label>
          <p>{{ details.create_time }}</p>
        </li>
        <li>
          <label>创建人员：</label>
          <p>{{ details.create_user_name }}</p>
        </li>
        <li v-show="details.customer_user_names != ''">
          <label>修改时间:</label>
          <p>{{ details.update_time }}</p>
        </li>
        <li v-show="details.customer_user_names != ''">
          <label>修改人员:</label>
          <p>{{ details.customer_user_names }}</p>
        </li>
      </ul>
    </section>
    <!-- info end -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      details: {}
    };
  },
  props: {
    detail: {}
  },
  mounted() {
    this.details = this.detail;
  },
  watch: {
    detail() {
      this.details = this.detail;
      console.log(this.details);
    }
  }
};
</script>
<style lang="less" scoped>
.info {
  margin: 30px 2% 0;
  h3 {
    line-height: 24px;
  }
  > ul {
    > li {
      display: inline-block;
      min-width: 33%;
      margin-bottom: 4px;
      padding-right: 10px;
      label,
      p {
        display: inline-block;
        font-size: 14px;
        line-height: 20px;
        max-width: 260px;
        vertical-align: top;
      }
    }
  }
}
</style>
